export default __webpack_public_path__ + "static/media/warning.7f4a6dd6.png";